import React, { memo, useEffect, useState } from 'react';
import { areEqual } from 'Utils/equalityChecks';

import classes from './opportunitySelector.module.css';

interface Opportunity {
  id: string;
  name: string;
}

interface Props {
  opportunities: Opportunity[];
  linkingOpportunity: boolean;
  onLinkOpportunity: (opportunityId: string) => void;
  linkedOpportunityId?: string;
}

function OpportunitySelector({ opportunities, linkingOpportunity, onLinkOpportunity, linkedOpportunityId }: Props) {
  const [selectedId, setSelectedId] = useState(linkedOpportunityId || '');

  // Keep selectedId in sync when linkedOpportunityId changes (e.g. after linking)
  useEffect(() => {
    setSelectedId(linkedOpportunityId || '');
  }, [linkedOpportunityId]);

  const hasChanged = selectedId !== (linkedOpportunityId || '');

  const handleSave = () => {
    if (selectedId && hasChanged) {
      onLinkOpportunity(selectedId);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.label}>CRM Opportunity</div>
      <div className={classes.selectorRow}>
        <select
          className={classes.select}
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
          disabled={linkingOpportunity}
        >
          <option value="">Select an opportunity...</option>
          {opportunities.map((opp) => (
            <option key={opp.id} value={opp.id}>
              {opp.name}
            </option>
          ))}
        </select>
        {hasChanged && (
          <button
            type="button"
            className={classes.linkButton}
            onClick={handleSave}
            disabled={!selectedId || linkingOpportunity}
          >
            {linkingOpportunity ? 'Saving...' : 'Save'}
          </button>
        )}
      </div>
    </div>
  );
}

const OpportunitySelectorMemo = memo(OpportunitySelector, areEqual);

export { OpportunitySelectorMemo as OpportunitySelector };
